<label class="form-label texto-secundario formulario-label texto-inter" [class.required]="required">{{ label }}</label>
<div class="input-senha" [class.input-senha--invalid]="invalid">
  <input
    [id]="inputId"
    [type]="mostrarSenha ? 'text' : 'password'"
    class="form-control input-senha__campo"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [disabled]="disabled"
    (change)="onChange(value)"
    (focus)="inputFocus()"
    (keyup)="inputKeyup(value)"
    [ngClass]="{'is-invalid': invalid}"
    [mask]="mask"
    [dropSpecialCharacters]="false"
    [readonly]="readonly"
    [attr.autocomplete]="autocomplete"
  />
  <button
    *ngIf="exibirToggle"
    type="button"
    class="input-senha__toggle"
    tabindex="-1"
    [attr.aria-label]="mostrarSenha ? 'Ocultar senha' : 'Exibir senha'"
    [attr.aria-pressed]="mostrarSenha"
    (click)="toggleMostrarSenha()"
  >
    <span class="material-symbols-outlined">{{ mostrarSenha ? 'visibility_off' : 'visibility' }}</span>
  </button>
</div>
<div class="invalid-feedback" [class.d-block]="invalid">
  <span>{{msgAlerta}}</span>
</div>
